import { render, staticRenderFns } from "./coaches.vue?vue&type=template&id=284862ee&"
import script from "./coaches.vue?vue&type=script&lang=js&"
export * from "./coaches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports